import {
  Checkbox,
  DatePicker,
  Flex,
  Form,
  Input,
  message,
  Select,
  Spin,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import PatientService from "../../Services/PatientService";
import CommonService from "../../Services/CommonService";
import { encodeBase64File } from "../../utils/encodeBase64";
import { validatePincode } from "../../utils/validation";

function AddFamilyMember({ handleCancel, handleSave, handleClose }) {
  const [profileImage, setProfileImage] = useState(null);
  const [firstLoad, setFirstLoad] = useState(false);
  const [dob, setDob] = useState();
  const [fields, setFields] = useState({
    firstname: "",
    lastname: "",
    city: "",
  });
  const [sosChecked, setSosChecked] = useState(false);
  const [loader, setLoader] = useState(false);
  const [relationList, setRelationList] = useState([]);
  const formRef = useRef();
  const fileInputRef = useRef(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const { patientData } = useSelector((state) => state.auth);
  const bloodgroup = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];

  useEffect(() => {
    // setFirstLoad(true);
    const payload = {
      status: 1,
    };
    getRelationsList();
    getCountriesList(payload);
  }, []);

  useEffect(() => {
    if (fields.firstname) {
      const formattedFirstname =
        fields.firstname.charAt(0).toUpperCase() +
        fields.firstname.slice(1).toLowerCase();
      form.setFieldsValue({ firstname: formattedFirstname });
    }
    if (fields.lastname) {
      const formattedLastname =
        fields.lastname.charAt(0).toUpperCase() +
        fields.lastname.slice(1).toLowerCase();
      form.setFieldsValue({ lastname: formattedLastname });
    }

    if (fields.city) {
      const formattedCityName =
        fields.city.charAt(0).toUpperCase() +
        fields.city.slice(1).toLowerCase();
      form.setFieldsValue({ city: formattedCityName });
    }
  }, [fields]);

  const getRelationsList = async () => {
    const payload = { status: 1 };
    try {
      const response = await PatientService.RelationList(payload);
      setRelationList(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const getCountriesList = async (payload) => {
    try {
      const response = await CommonService.CountriesList(payload);
      setCountries(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const StateList = async (country_Id) => {
    let payload = { status: 1 };
    if (country_Id) {
      payload.country_Id = country_Id;
    }
    try {
      const response = await CommonService.StatesList(payload);
      setStates(response.data || []);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchCities = async (state_Id) => {
    const payload = { status: 1, state_Id };
    try {
      const response = await CommonService.CityList(payload);
      setCities(response.data || []);
    } catch (e) {
      console.error(e);
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleUserPicChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size <= 1048576) {
      setProfileImage(file);
    } else {
      message.error("Image/file size should be less than or equal to 1 mb !!");
      return;
    }
  };

  const handleDob = (value, valueString) => {
    setDob(valueString);
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validatePhoneNumber = (number) => /^\d{10}$/.test(number);



  const handlePatientSave = async () => {
    const {
      salutation,
      firstname,
      lastname,
      relationCode,
      email,
      mobile,
      gender,
      maritalStatus,
      bloodGroup,
      addressOne,
      addressTwo,
      city,
      patientState,
      country,
      pincode,
      erContactNo1,
      erContactNo2,
      erContactNo3,
      erContactNo4,
      erContactNo5,
    } = formRef.current.getFieldValue();
    const currDate = new Date().toISOString();
    const date = currDate.split("T")[0];
    const time = currDate.split("T")[1].slice(0, 8);
    const constructedTime = date + " " + time;

    if (!firstname || !lastname || !mobile || !relationCode) {
      message.error("Please fill in all mandatory fields");
      return;
    }

    if (!validatePhoneNumber(mobile)) {
      message.error("Please enter a valid 10-digit mobile number.");
      return;
    }

    if (email && !validateEmail(email)) {
      message.error("Please enter a valid mail id.");
      return;
    }
    if (pincode && !validatePincode(pincode)) {
      message.error("Please enter a valid Postal Code.");
      return;
    }

    if (sosChecked) {
      if (!erContactNo1 || !erContactNo2 || !erContactNo3 || !erContactNo4) {
        message.error("Please fill in all mandatory fields for SOS");
        return;
      }
    }

    if (patientData?.mobile === mobile) {
      message.error(
        "This number is already there. please prvoide alternative number.",
      );
      return;
    }

    const relationDesc = relationList?.find(
      (rel) => rel.relationCode === relationCode,
    )?.relationDescription;

    const payload = {
      account_Id: patientData?.account_Id,
      account_Name: null,
      address1: addressOne ? addressOne : null,
      address2: addressTwo ? addressTwo : null,
      bloodGroup: bloodGroup ? bloodGroup : null,
      city: city ? city : null,
      clinic_Id: patientData?.clinic_Id,
      clinic_Name: null,
      country: country ? country : null,
      createdBy: patientData?.patientId,
      createdDate: constructedTime,
      dob: dob ? dob : null,
      email: email ? email : null,
      firstName: firstname,
      gender,
      lastName: lastname,
      loginId: null,
      loginIdAvailableYN: null,
      maritalStatus: maritalStatus ? maritalStatus : null,
      meetingLink: null,
      mobile,
      modifiedBy: patientData.patientId,
      modifiedDate: constructedTime,
      parentPatientId: patientData?.patientId,
      parentPatientName: patientData?.firstName + " " + patientData?.lastName,
      patientId: null,
      patientRegFee: 0,
      patientRegFeeYN: null,
      photo: null,
      photoName: null,
      photoType: null,
      pinCode: pincode ? pincode : null,
      relationCode,
      relationDescription: relationDesc,
      salutation: salutation ? salutation : null,
      state: patientState ? patientState : null,
      status: 1,
      userId: patientData?.createdBy,
      userName: patientData?.userName,
      rpmApplicable: "N",
      patientChronicConditionsList: [],
      patientDevicesList: [],
      patientVitalsConfigList: {
        bloodGlucose: 0,
        bmi: 1,
        diastolic: 1,
        heartRate: 0,
        height: 1,
        respiratoryRate: 0,
        spo2: 0,
        systolic: 1,
        temperature: 0,
        weight: 1,
        breathing: 1,
        pulse: 1,
        spirometry: 1,
        createdBy: "",
        modifiedBy: "",
        status: 1,
      },
      patientVitalsRangeList: [],
      hospitalId: "",
      locationId: "",
      uhId: "",
      insuranceId1: "",
      insuranceId2: "",
      insuranceName1: "",
      insuranceName2: "",
      patientGroupNumber: "",
      height: 0,
      weight: 0,
      providerName: "",
      providerCode: "",
      patientRegConsentDtlList: [],
      sos: sosChecked ? "Y" : "N",
      erContactNo1: erContactNo1 ? erContactNo1 : "",
      erContactNo2: erContactNo2 ? erContactNo2 : "",
      erContactNo3: erContactNo3 ? erContactNo3 : "",
      erContactNo4: erContactNo4 ? erContactNo4 : "",
      erContactNo5: erContactNo5 ? erContactNo5 : "",
      rpmSmartWatch: "N",
      smartWatchUserId: "",
    };

    if (profileImage) {
      const res = await encodeBase64File(profileImage);
      payload.imageName = profileImage.name;
      if (profileImage?.type.includes("pdf")) {
        payload.photoType = "pdf";
        payload.photo = res;
      } else if (profileImage?.type.includes("png")) {
        payload.photoType = "png";
        payload.photo = res;
      } else if (profileImage?.type.includes("jpg")) {
        payload.photoType = "jpg";
        payload.photo = res;
      } else if (profileImage?.type.includes("jpeg")) {
        payload.photoType = "jpeg";
        payload.photo = res;
      }
    }

    setLoader(true);
    try {
      await PatientService.AddPatient(payload);
      message.success("Patient created successfully!!");
      setProfileImage(null);
      formRef.current.resetFields();
      await handleSave();
      handleClose();
      setLoader(false);
    } catch (e) {
      setLoader(false);
      console.error(e);
      e && message.error(e.response.data.message);
    }
  };

  const handleSosChange = () => {
    setSosChecked(!sosChecked);
  };

  return (
    <>
      {firstLoad ? (
        <div className="min-h-[50vh] flex items-center justify-center mt-[10%]">
          <Flex align="center" gap="middle">
            <Spin size="large" tip="Loading" />
          </Flex>
        </div>
      ) : (
        <>
          <div>
            <Form
              ref={formRef}
              form={form}
              disabled={loader}
              className="w-full grid grid-cols-4 sm:grid-cols-1 gap-2 justify-center items-center"
            >
              <div>
                <div className="flex flex-col m-auto" onClick={handleClick}>
                  <div className="Upload h-28 w-28 border-2 border-dashed  rounded-full cursor-pointer relative">
                    <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleUserPicChange}
                      ref={fileInputRef}
                    />
                    <div className="absolute  bottom-0 right-0 rounded-full text-center w-6 h-6 z-[1] p-1 bg-slate-300 cursor-pointer">
                      <div className=" flex justify-center mt-1 items-center">
                        <PlusOutlined />
                      </div>
                    </div>
                    {profileImage && (
                      <img
                        src={URL.createObjectURL(profileImage)}
                        alt="Profile"
                        className={`absolute top-0 left-0  h-full object-contain rounded-full`}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="">
                <div className="">
                  <div className="">
                    <label className=" sm:text-sm font-medium ">
                      Salutation
                    </label>
                  </div>
                  <Form.Item name="salutation" className="w-4/5 p-1">
                    <Select
                      placeholder="Select Salutation"
                      className="h-8 outline-none border-2 rounded-lg"
                      allowClear
                    >
                      <Select.Option value={"Mr."}>Mr</Select.Option>
                      <Select.Option value={"Miss."}>Miss</Select.Option>
                      <Select.Option value={"Mrs."}>Mrs</Select.Option>
                    </Select>
                  </Form.Item>
                </div>
              </div>

              <div className="">
                <div className="">
                  <div className="">
                    <label className="text-lg sm:text-sm  font-medium">
                      First Name
                      <span className="text-red-500">*</span>
                    </label>
                  </div>
                  <Form.Item name="firstname">
                    <Input
                      type="text"
                      placeholder="FirstName"
                      name="firstname"
                      className="w-4/5  h-8  outline-none border-2 p-1 rounded-lg"
                      onChange={(e) => {
                        const value = e.target.value;
                        const formattedValue =
                          value.charAt(0).toUpperCase() +
                          value.slice(1).toLowerCase();
                        setFields((prevState) => ({
                          ...prevState,
                          firstname: formattedValue,
                        }));
                      }}
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="">
                <div className="">
                  <div className="">
                    <label className="text-lg sm:text-sm  font-medium">
                      Last Name
                      <span className="text-red-500">*</span>
                    </label>
                  </div>
                  <Form.Item name="lastname">
                    <Input
                      type="text"
                      placeholder="LastName"
                      name="lastname"
                      className="w-4/5  h-8  outline-none border-2 p-1 rounded-lg"
                      onChange={(e) => {
                        const value = e.target.value;
                        const formattedValue =
                          value.charAt(0).toUpperCase() +
                          value.slice(1).toLowerCase();
                        setFields((prevState) => ({
                          ...prevState,
                          lastname: formattedValue,
                        }));
                      }}
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="">
                <div className="">
                  <div className="">
                    <label className=" sm:text-sm font-medium ">
                      Relation
                      <span className="text-red-500">*</span>
                    </label>
                  </div>
                  <Form.Item name="relationCode" className="w-4/5   p-1">
                    <Select
                      placeholder="Select relationship"
                      className="h-8 outline-none border-2 rounded-lg"
                      options={relationList?.map((relation, idx) => {
                        return {
                          label: relation.relationDescription,
                          value: relation.relationCode,
                          key: idx,
                        };
                      })}
                      showSearch
                      allowClear
                      filterOption={(option, input) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="">
                <div className="">
                  <div className="">
                    <label className="text-lg sm:text-sm font-medium">
                      Mobile
                      <span className="text-red-500">*</span>
                    </label>
                  </div>
                  <Form.Item name="mobile">
                    <Input
                      placeholder="Enter mobile No"
                      name="mobile"
                      className="w-4/5  h-8 outline-none border-2  p-1 rounded-lg"
                      maxLength={10}
                      onKeyDown={(event) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "Tab",
                          "ArrowLeft",
                          "ArrowRight",
                        ];

                        if (
                          !/[0-9]/.test(event.key) &&
                          !allowedKeys.includes(event.key)
                        ) {
                          event.preventDefault(); // Prevent non-numeric and non-control key input
                        }
                      }}
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="">
                <div className="">
                  <div className="">
                    <label className="text-lg sm:text-sm font-medium">
                      Email
                    </label>
                  </div>
                  <Form.Item name="email">
                    <Input
                      type="email"
                      placeholder="Enter email"
                      name="email"
                      className="w-4/5   h-8 outline-none border-2  rounded-lg"
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="">
                <div className="">
                  <div className="">
                    <label className="text-lg sm:text-sm  font-medium">
                      Date Of Birth
                    </label>
                  </div>
                  <Form.Item name="dob" className="w-4/5  py-2">
                    <DatePicker
                      placeholder="Date of birth"
                      format="MM/DD/YYYY"
                      className=" h-8 border-2 rounded-lg"
                      onChange={handleDob}
                      disabledDate={(current) =>
                        current && current.valueOf() > Date.now()
                      }
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="">
                <div className="">
                  <div className="">
                    <label className="text-lg sm:text-sm  font-medium">
                      Gender
                    </label>
                  </div>
                  <Form.Item name="gender" className="w-4/5  py-2">
                    <Select
                      placeholder="Select Gender"
                      className="h-8 border-2 rounded-lg"
                      allowClear
                    >
                      <Select.Option value="M">Male</Select.Option>
                      <Select.Option value="F">Female</Select.Option>
                    </Select>
                  </Form.Item>
                </div>
              </div>

              <div className="">
                <div className="">
                  <div className="">
                    <label className=" sm:text-sm font-medium ">
                      Marital Status
                    </label>
                  </div>
                  <Form.Item name="maritalStatus" className="w-4/5  py-1">
                    <Select
                      placeholder="Marital Status"
                      className="h-8 outline-none border-2 rounded-lg"
                      allowClear
                    >
                      <Select.Option value={"M"}>Married</Select.Option>
                      <Select.Option value={"U"}>Unmarried</Select.Option>
                    </Select>
                  </Form.Item>
                </div>
              </div>

              <div className="">
                <div className="">
                  <div className="">
                    <label className=" sm:text-sm font-medium ">
                      Blood Group
                    </label>
                  </div>
                  <Form.Item name="bloodGroup" className="w-4/5   py-1">
                    <Select
                      placeholder="Blood Group"
                      className="h-8 outline-none border-2 rounded-lg"
                      allowClear
                    >
                      {bloodgroup.map((option) => (
                        <Select.Option key={option} value={option}>
                          {option}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>

              <div className="">
                <div className="">
                  <div className="">
                    <label className="text-lg sm:text-sm font-medium">
                      Address 1
                    </label>
                  </div>
                  <Form.Item name="addressOne">
                    <Input
                      placeholder="Address 1"
                      name="addressOne"
                      className="w-4/5  h-8 outline-none border-2  p-1 rounded-lg"
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="">
                <div className="">
                  <div className="">
                    <label className="text-lg sm:text-sm  font-medium">
                      Address 2
                    </label>
                  </div>
                  <Form.Item name="addressTwo">
                    <Input
                      placeholder="Address 2"
                      name="addressTwo"
                      className="w-4/5  h-8 outline-none border-2  p-1 rounded-lg"
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="">
                <div className="">
                  <div className="">
                    <label className="text-lg sm:text-sm font-medium">
                      Country
                    </label>
                  </div>
                  <Form.Item name="country" className="w-4/5">
                    <Select
                      className="bg-lightBlue border-2 h-8 rounded-lg"
                      placeholder="Select Country"
                      allowClear
                      onChange={(value) => {
                        form.setFieldsValue({
                          patientState: undefined,
                          city: undefined,
                        });
                        if (value) {
                          StateList(value);
                        }
                      }}
                    >
                      {countries?.map((country) => (
                        <Select.Option
                          key={country.country_Id}
                          value={country.country_Id}
                        >
                          {country.country_Name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>

              <div className="">
                <div className="">
                  <div className="">
                    <label className="text-lg sm:text-sm font-medium">
                      State
                    </label>
                  </div>
                  <Form.Item name="patientState" className="w-4/5 ">
                    <Select
                      showSearch
                      className="bg-brand-lightBlue border-2 h-8 rounded-lg"
                      placeholder="Select State"
                      onChange={(value) => {
                        // reset city when state changes
                        form.setFieldsValue({ city: undefined });
                        fetchCities(value);
                      }}
                      options={states?.map((state) => ({
                        label: state.stateName,
                        value: state.stateId,
                      }))}
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      allowClear
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="">
                <div className="">
                  <div className="">
                    <label className="text-lg sm:text-sm  font-medium">
                      City
                    </label>
                  </div>
                  <Form.Item name="city" className="w-4/5 ">
                    <Select
                      showSearch
                      placeholder="Select City"
                      options={cities?.map((c) => ({
                        label: c.cityName,
                        value: c.cityName,
                      }))}
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      allowClear
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="">
                <div className="">
                  <div className="">
                    <label className="text-lg sm:text-sm font-medium">
                      Postal Code
                    </label>
                  </div>
                  <Form.Item name="pincode">
                    <Input
                      placeholder="Postal Code"
                      name="pincode"
                      maxLength={6}
                      onKeyDown={(event) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "Tab",
                          "ArrowLeft",
                          "ArrowRight",
                        ];

                        if (
                          !/[0-9]/.test(event.key) &&
                          !allowedKeys.includes(event.key)
                        ) {
                          event.preventDefault(); // Prevent non-numeric and non-control key input
                        }
                      }}
                      className="w-4/5 h-8  p-1 outline-none border-2 rounded-lg"
                    />
                  </Form.Item>
                </div>
              </div>

              {/* <div className="">
                <div className="">
                  <div className="">
                    <label className="text-lg  font-medium">SOS</label>
                  </div>
                  <Form.Item valuePropName="checked" name="sosChecked">
                    <Checkbox onChange={handleSosChange} />
                  </Form.Item>
                </div>
              </div> */}

              {sosChecked && (
                <>
                  <div className="">
                    <div className="">
                      <div className="">
                        <label className="text-lg sm:text-sm font-medium">
                          Contact 1<span className="text-red-500">*</span>
                        </label>
                      </div>
                      <Form.Item name="erContactNo1">
                        <Input
                          placeholder="Emergency Contact No 1"
                          name="mobile"
                          className="w-4/5  h-8 outline-none border-2  p-1 rounded-lg"
                          maxLength={10}
                          onKeyDown={(event) => {
                            const allowedKeys = [
                              "Backspace",
                              "Delete",
                              "Tab",
                              "ArrowLeft",
                              "ArrowRight",
                            ];

                            if (
                              !/[0-9]/.test(event.key) &&
                              !allowedKeys.includes(event.key)
                            ) {
                              event.preventDefault(); // Prevent non-numeric and non-control key input
                            }
                          }}
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="">
                    <div className="">
                      <div className="">
                        <label className="text-lg sm:text-sm font-medium">
                          Contact 2<span className="text-red-500">*</span>
                        </label>
                      </div>
                      <Form.Item name="erContactNo2">
                        <Input
                          placeholder="Emergency Contact No 2"
                          name="mobile"
                          className="w-4/5  h-8 outline-none border-2  p-1 rounded-lg"
                          maxLength={10}
                          onKeyDown={(event) => {
                            const allowedKeys = [
                              "Backspace",
                              "Delete",
                              "Tab",
                              "ArrowLeft",
                              "ArrowRight",
                            ];

                            if (
                              !/[0-9]/.test(event.key) &&
                              !allowedKeys.includes(event.key)
                            ) {
                              event.preventDefault(); // Prevent non-numeric and non-control key input
                            }
                          }}
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="">
                    <div className="">
                      <div className="">
                        <label className="text-lg sm:text-sm font-medium">
                          Contact 3<span className="text-red-500">*</span>
                        </label>
                      </div>
                      <Form.Item name="erContactNo3">
                        <Input
                          placeholder="Emergency Contact No 3"
                          name="mobile"
                          className="w-4/5  h-8 outline-none border-2  p-1 rounded-lg"
                          maxLength={10}
                          onKeyDown={(event) => {
                            const allowedKeys = [
                              "Backspace",
                              "Delete",
                              "Tab",
                              "ArrowLeft",
                              "ArrowRight",
                            ];

                            if (
                              !/[0-9]/.test(event.key) &&
                              !allowedKeys.includes(event.key)
                            ) {
                              event.preventDefault(); // Prevent non-numeric and non-control key input
                            }
                          }}
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="">
                    <div className="">
                      <div className="">
                        <label className="text-lg sm:text-sm font-medium">
                          Contact 4<span className="text-red-500">*</span>
                        </label>
                      </div>
                      <Form.Item name="erContactNo4">
                        <Input
                          placeholder="Emergency Contact No 4"
                          name="mobile"
                          className="w-4/5  h-8 outline-none border-2  p-1 rounded-lg"
                          maxLength={10}
                          onKeyDown={(event) => {
                            const allowedKeys = [
                              "Backspace",
                              "Delete",
                              "Tab",
                              "ArrowLeft",
                              "ArrowRight",
                            ];

                            if (
                              !/[0-9]/.test(event.key) &&
                              !allowedKeys.includes(event.key)
                            ) {
                              event.preventDefault(); // Prevent non-numeric and non-control key input
                            }
                          }}
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="">
                    <div className="">
                      <div className="">
                        <label className="text-lg sm:text-sm  font-medium">
                          Contact 5 (Medical Contact)
                        </label>
                      </div>
                      <Form.Item name="erContactNo5">
                        <Input
                          placeholder="Emergency Contact No 5"
                          name="mobile"
                          className="w-4/5  h-8 outline-none border-2  p-1 rounded-lg"
                          maxLength={10}
                          onKeyDown={(event) => {
                            const allowedKeys = [
                              "Backspace",
                              "Delete",
                              "Tab",
                              "ArrowLeft",
                              "ArrowRight",
                            ];

                            if (
                              !/[0-9]/.test(event.key) &&
                              !allowedKeys.includes(event.key)
                            ) {
                              event.preventDefault(); // Prevent non-numeric and non-control key input
                            }
                          }}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </>
              )}
            </Form>
          </div>
          <div className="flex  text-center  items-end justify-end gap-3 ">
            <button
              disabled={loader}
              className=" w-[5rem]  h-8 p-1 bg-brand-White rounded-lg border text-brand-primaryColor border-brand-primaryColor font-semibold custom-button-shadow"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              disabled={loader}
              className=" w-[5rem] h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50"
              onClick={handlePatientSave}
            >
              Save
            </button>
          </div>
        </>
      )}
    </>
  );
}

export default AddFamilyMember;
